export enum EntityFormId {
    Create = 'create',
    QuickCreate = 'quick-create',
    CreateWithTemplate = 'create-with-template',
    Manage = 'manage',
    ManageFinancial = 'manage-financial',
    ManageTablet = 'manage-tablet',
}